import { bool, func, shape, string } from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { get_yes_bank_otp, select_card_data_ybl, select_isBoolean, set_channel_flag } from '../NetworkCards/selectors';
import { SetChannelFlag, getOtp } from '../NetworkCards/actions';
import { GET_OTP_SUCCESS, SET_CHANNEL_FLAG_SUCCESS } from '../NetworkCards/constants';
import { selectHeaderContainerJS } from '../HeaderContainer/selectors';
import { fetchCardData } from './actions';

export const YesBankRenewalManagementPropTypes = {
  isLoadingStatus: bool.isRequired,
  location: shape({}).isRequired,
  match: shape({
    params: shape({
      id: string,
      type: string,
    }),
  }).isRequired,
  CardDataYbl: shape({}).isRequired,
  SelectUserDetails: shape({}).isRequired,
  GetYesBankOtpSuccess: shape({}).isRequired,
  SetChannelFlagSuccess: shape({}).isRequired,
  onGetOtp: func.isRequired,
  onGetOtpSuccess: func.isRequired,
  onSetChannelFlag: func.isRequired,
  onFetchCardData: func.isRequired,
  onSetChannelFlagSuccess: func.isRequired,
};

export const YesBankRenewalManagementStateToProps = createStructuredSelector({
  CardDataYbl: select_card_data_ybl(),
  SelectUserDetails: selectHeaderContainerJS('userDetails'),
  GetYesBankOtpSuccess: get_yes_bank_otp('getOtpSuccess'),
  isLoadingStatus: select_isBoolean('isLoading'),
  SetChannelFlagSuccess: set_channel_flag('setChannelFlagSuccess'),
});

export const YesBankRenewalManagementDispatchToProps = (dispatch) => ({
  onGetOtp: (payload) => dispatch(getOtp(payload)),
  onGetOtpSuccess: () => dispatch({ type: GET_OTP_SUCCESS, payload: { status: false } }),
  onSetChannelFlag: (payload, cardType) => dispatch(SetChannelFlag(payload, cardType)),
  onSetChannelFlagSuccess: () => dispatch({ type: SET_CHANNEL_FLAG_SUCCESS, payload: { status: false } }),
  onFetchCardData: (payload) => dispatch(fetchCardData(payload)),
});




// WEBPACK FOOTER //
// client/containers/YesBankRenewalManagement/yesBankRenewalManagementDataHandler.js